import React, { useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Accordion from "react-bootstrap/Accordion";

import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";

import { Calendar } from "primereact/calendar";

import axios from "axios";

import { Toast } from "primereact/toast";
import Spinner from "react-bootstrap/Spinner";

import "../my_styles/landing_page_styles.css";
import logo from "./logo_2.png";
//
//
//
function BookCut(props) {
  const show = props.show;
  const setShow = props.setShow;

  const handleClose = () => setShow(false);

  const toast = useRef(null);

  const {
    timeError,
    isLoading: isTimeLoading,
    data: time,
  } = useFetch(`${main_link}scheduleIndexVisitor`);

  const {
    error,
    isLoading: loadingBarber,
    data: barber,
  } = useFetch(`${main_link}getBarbers`);

  const {
    errorCuts,
    isLoading: isLoadingCuts,
    data: cuts,
  } = useFetch(`${main_link}visitorShowCut`);

  // Toggle  barber
  const handleToggle = (id, barberName) => {
    setDate("");
    setShowTime("");
    setTimeColor("");
    setSelectedBarberId((prevId) => {
      // If the same barber is clicked, set it to null, otherwise set it to the new ID
      if (prevId === id) {
        setSelectedBarber(null); // Clear the barber name if toggled off
        return null;
      } else {
        setSelectedBarber(barberName); // Set the barber name when toggled on
        return id;
      }
    });
  };

  const handleToggleHair = (id, hair, price) => {
    setSelectedHairID((prevId) => (prevId === id ? null : id)); // Toggle off if the same barber is clicked
    setSelectedHairName(hair);
    setHPrice(price);

    const checkbox = document.getElementById(`toggle-check-${id}`);
    if (checkbox && !checkbox.checked) {
      setSelectedHairID("");
      setSelectedHairName("");
      setHPrice(0);
    }
  };

  const handleToggleBeard = (id, beard, price) => {
    setSelectedBeardID((prevId) => (prevId === id ? null : id)); // Toggle off if the same barber is clicked
    setSelectedBeardName(beard);
    setBPrice(price);

    const checkbox = document.getElementById(`toggle-check-${id}`);
    if (checkbox && !checkbox.checked) {
      setSelectedBeardID("");
      setSelectedBeardName("");
      setBPrice(0);
    }
  };

  const handleToggleFace = (id, face, price) => {
    setSelectedFaceID((prevId) => (prevId === id ? null : id)); // Toggle off if the same barber is clicked
    setSelectedFaceName(face);
    setFPrice(price);

    const checkbox = document.getElementById(`toggle-check-${id}`);
    if (checkbox && !checkbox.checked) {
      setSelectedFaceID("");
      setSelectedFaceName("");
      setFPrice(0);
    }
  };

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [selectedBarberId, setSelectedBarberId] = useState(null);
  const [selectedBarber, setSelectedBarber] = useState();

  const [selectedHairID, setSelectedHairID] = useState();
  const [selectedHairName, setSelectedHairName] = useState();

  const [selectedFaceID, setSelectedFaceID] = useState();
  const [selectedFaceName, setSelectedFaceName] = useState();

  const [selectedBeardID, setSelectedBeardID] = useState();
  const [selectedBeardName, setSelectedBeardName] = useState();

  const [bPrice, setBPrice] = useState(0);
  const [fPrice, setFPrice] = useState(0);
  const [hPrice, setHPrice] = useState(0);

  const [day, setDay] = useState("");
  const [date, setDate] = useState("");
  const [showTime, setShowTime] = useState([]);
  const [timeColor, setTimeColor] = useState("");
  const [cutTime, setCutTime] = useState("");
  const [dateOnly, setDateOnly] = useState();
  const [isFullTime, setIsFullTime] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingTime, setLoadingTime] = useState(false); // when user changes the calednar day
  const createAppoitment = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);

    const loadingOverlay = document.getElementById("loadingOverlay");

    try {
      const response = await axios.post(main_link + "bookCut", {
        name: name,
        phone: phone,
        email: email,
        selectedBarberId: selectedBarberId,
        selectedHairID: selectedHairID,
        selectedFaceID: selectedFaceID,
        selectedBeardID: selectedBeardID,
        dateOnly: dateOnly,
        cutTime: cutTime,
        hair_price: hPrice,
        face_price: fPrice,
        beard_price: bPrice,
      });
      setLoadingSubmit(false);
      // console.log(response);
      if (response.data.message == "Data successfully Added!") {
        toast.current.show({
          severity: "success",
          summary: "success",
          detail:
            "Thank you for booking your appointment at Shawn's Barber Shop! We look forward to seeing you.",
        });

        loadingOverlay.style.display = "flex"; // show overlay logo

        document.getElementById("bookingForm").reset();
        // clearValues();
        setShow(false);
      }
    } catch (error) {
      loadingOverlay.style.display = "none";
      // console.log(error.response.data.message);
      setLoadingSubmit(false);

      if (error.response.data.message) {
        toast.current.show({
          severity: "info",
          summary: "Info",
          detail: error.response.data.message,
        });
      }
    }
  };

  // show the message when customer takes appointment
  function closeOverlay() {
    const overlay = document.getElementById("loadingOverlay");
    overlay.style.display = "none"; // Hide the overlay when the button is clicked
  }

  const clearValues = () => {
    setName("");
    setPhone("");
    setEmail("");

    setSelectedBarberId(null);
    setSelectedBarber(null);

    setSelectedHairID(null);
    setSelectedHairName("");

    setSelectedFaceID(null);
    setSelectedFaceName("");

    setSelectedBeardID(null);
    setSelectedBeardName("");

    setBPrice(0);
    setFPrice(0);
    setHPrice(0);

    setDay("");
    setDate("");
    setShowTime([]);

    setTimeColor("");
    setCutTime("");
    setDateOnly("");
  };

  const select_date_fn = (date, e) => {
    setLoadingTime(true);
    // e.originalEvent.target.style.backgroundColor = "red";
    // const parentElement = e.originalEvent.target.parentElement;
    // parentElement.classList.add("parentClass");

    if (!selectedBarberId) {
      setLoadingTime(false);
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "You must select a barber before choosing a date",
      });
      setLoadingTime(false);
      return;
    }

    document.getElementById("choose_time_section").scrollIntoView({
      behavior: "smooth",
    });

    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const dayOnly = date.toLocaleDateString("en-US", { weekday: "long" });
    setDateOnly(date.toLocaleDateString("en-US", options));
    setDay(dayOnly);

    // Filter time for the selected day
    const filteredTime = time.filter((t) => t.day === dayOnly);

    // console.log("Filtered Time for Day:", dayOnly, filteredTime);

    // Pass the filtered time to removeBookedTime
    removeBookedTime(date, filteredTime);
  };

  async function removeBookedTime(date, filteredTime) {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    const selected_date = date.toLocaleDateString("en-US", options);

    // Fetch booked time for the selected date and barber
    const booked_time = await fetchAndLogBookedCuts(
      selected_date,
      selectedBarberId
    );

    if (Array.isArray(booked_time)) {
      const bookedTimesArray = booked_time.flatMap((t) => t.time || []);

      const updatedShowTime = (filteredTime || []).map((item) => ({
        ...item,
        time: (item.time || []).filter(
          (time) => !bookedTimesArray.includes(time)
        ),
      }));

      if (
        Array.isArray(updatedShowTime.time) &&
        updatedShowTime.time.length === 0
      ) {
        setIsFullTime(bookedTimesArray);
      } else {
        // console.error(time);
        setShowTime(updatedShowTime);
      }
      setLoadingTime(false);
    } else {
      // console.error("Expected an array for booked_time, but got:", booked_time);
      // console.error("Expected For Booked Time :");
    }
  }

  const fetchAndLogBookedCuts = async (selected_date, selected_barber) => {
    try {
      const response = await fetch(
        `${main_link}bookedCutsTimeAndDateAndBarber?date=${selected_date}&barber=${selected_barber}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      // console.log("Booked Cuts Data:", data);
      return data;
    } catch (error) {
      // console.error("Error fetching booked cuts:", error);
      return { data: null, error };
    }
  };

  return (
    <>
      <div id="loadingOverlay">
        <div id="loadingContent">
          <img src={logo} alt="Loading..." id="loadingLogo" />

          <h3 className="text">
            Thank you for booking your appointment at
            <br />
            <h1>Shawn's Barber Shop</h1>
            We look forward to seeing you soon.
          </h3>

          <div className="detailsContainer">
            <h4 className="details">
              <strong>Day:</strong> {dateOnly}
            </h4>
            <h4 className="details">
              <strong>Time:</strong> {cutTime}
            </h4>
            <h4 className="details">
              <strong>Barber:</strong> {selectedBarber}
            </h4>
          </div>

          <h1>Shortly, an email will be sent to you.</h1>

          <div className="buttonsContainer">
            <Button
              size="lg"
              onClick={() => {
                closeOverlay();
                clearValues(); // Clear values on click
              }}
              className="bg-danger"
            >
              Close
            </Button>

            <Button
              size="lg"
              onClick={() => {
                setShow(true);
                closeOverlay();
                clearValues();
              }}
              className="bg-success"
            >
              Create Another Appointment?
            </Button>
          </div>
        </div>
      </div>

      <Toast ref={toast} />
      <Modal
        show={show}
        onHide={handleClose}
        scrollable="true"
        size="xl"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Schedule your next cut with ease!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="bookingForm">
            <h4>Your Profile</h4>
            <hr />
            <Row>
              <Col lg={4} md={12} sm={12}>
                <Form.Group className="mb-3" controlId="nameInput">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="John John"
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col lg={4} md={12} sm={12}>
                <Form.Group className="mb-3" controlId="phoneInput">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="+1 780 446..."
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col lg={4} md={12} sm={12}>
                <Form.Group className="mb-3" controlId="emailInput">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <br />
            <h4>Choose Your Barber</h4>
            <hr />
            <Row>
              <Col>
                {loadingBarber && (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                )}
                {!loadingBarber &&
                  barber &&
                  barber.map((b) => (
                    <ButtonGroup className="mb-2 p-1" key={b.decryptedId}>
                      <ToggleButton
                        id={`toggle-check-${b.decryptedId}`}
                        type="checkbox"
                        variant="outline-primary"
                        checked={selectedBarberId === b.decryptedId}
                        value={b.decryptedId}
                        onChange={() => handleToggle(b.decryptedId, b.name)}
                      >
                        {b.name}
                      </ToggleButton>
                    </ButtonGroup>
                  ))}
              </Col>
            </Row>
            <br />

            <h4>Choose Your Cut</h4>
            <hr />

            {isLoadingCuts && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}

            {!isLoadingCuts && (
              <Accordion>
                <Accordion.Item defaultActiveKey={["0"]} alwaysOpen>
                  <Accordion.Header alwaysOpen>
                    <h6>Hair Style</h6>&nbsp;
                    {selectedHairName && (
                      <span className="selected_style ">
                        &nbsp;{selectedHairName}{" "}
                        <small style={{ fontSize: "16px" }}>$</small>
                        {hPrice} ✔️
                      </span>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    {cuts &&
                      cuts
                        .filter((b) => b.type == "Hair")
                        .map((b) => (
                          <ButtonGroup className="mb-2 p-1" key={b.cut_id}>
                            <ToggleButton
                              id={`toggle-check-${b.cut_id}`}
                              type="checkbox"
                              variant="outline-primary"
                              checked={selectedHairID === b.cut_id}
                              value={b.id}
                              onChange={() =>
                                handleToggleHair(b.cut_id, b.name, b.price)
                              }
                            >
                              {b.name}{" "}
                              <span className="price_style">{b.price} </span>
                            </ToggleButton>
                          </ButtonGroup>
                        ))}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <h6>Beard Style </h6>{" "}
                    {selectedBeardName && (
                      <span className="selected_style">
                        &nbsp;{selectedBeardName}{" "}
                        <small style={{ fontSize: "16px" }}>$</small>
                        {bPrice}✔️
                      </span>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    {cuts &&
                      cuts
                        .filter((b) => b.type == "Beard")
                        .map((b) => (
                          <ButtonGroup className="mb-2 p-1" key={b.cut_id}>
                            <ToggleButton
                              id={`toggle-check-${b.cut_id}`}
                              type="checkbox"
                              variant="outline-primary"
                              checked={selectedBeardID === b.cut_id}
                              value={b.id}
                              onChange={() =>
                                handleToggleBeard(b.cut_id, b.name, b.price)
                              }
                            >
                              {b.name}{" "}
                              <span className="price_style">{b.price}</span>
                            </ToggleButton>
                          </ButtonGroup>
                        ))}
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <h6>Face Style </h6>{" "}
                    {selectedFaceName && (
                      <span className="selected_style">
                        &nbsp; {selectedFaceName}{" "}
                        <small style={{ fontSize: "16px" }}>$</small> {fPrice}✔️
                      </span>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    {cuts &&
                      cuts
                        .filter((b) => b.type == "Face")
                        .map((b) => (
                          <ButtonGroup className="mb-2 p-1" key={b.cut_id}>
                            <ToggleButton
                              id={`toggle-check-${b.cut_id}`}
                              type="checkbox"
                              variant="outline-primary"
                              checked={selectedFaceID === b.cut_id}
                              value={b.id}
                              onChange={() =>
                                handleToggleFace(b.cut_id, b.name, b.price)
                              }
                            >
                              {b.name}{" "}
                              <span className="price_style">{b.price}</span>
                            </ToggleButton>
                          </ButtonGroup>
                        ))}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            )}

            <br />
            <br />
            <h4>Choose Date</h4>
            <hr />
            <Row>
              <Col>
                <div className="card flex justify-content-center">
                  <Calendar
                    value={date}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      select_date_fn(selectedValue, e);
                    }}
                    inline
                    minDate={new Date()}
                  />
                </div>
              </Col>
            </Row>

            <h4 id="choose_time_section">
              Choose Time{" "}
              {isTimeLoading && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
              {!isTimeLoading && dateOnly && (
                <span className="choose_time_section">Available Time in </span>
              )}
              {dateOnly && <span className="selected_style">{dateOnly}</span>}
            </h4>
            <hr />

            <Row>
              <Col>
                {loadingTime && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="large"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                {showTime &&
                  showTime.map((t) =>
                    t.time.map((time) => (
                      <span
                        key={time}
                        onClick={(e) => {
                          setCutTime(time);
                          setTimeColor(time);
                        }}
                        className={
                          timeColor == time
                            ? "time-slot select_time_color"
                            : "time-slot"
                        }
                      >
                        {time}
                      </span>
                    ))
                  )}
                {showTime.length > 0 &&
                  showTime.every((item) => item.time.length === 0) && (
                    <span
                      style={{
                        fontStyle: "italic",
                        fontSize: "19px",
                        fontWeight: "bold",
                      }}
                    >
                      ‼️No available time for this date. Please select a
                      different date or Barber.
                    </span>
                  )}
              </Col>
            </Row>
            <br />
            <h4>Check Out</h4>
            <hr />

            <Row>
              <Col>
                <div className="checkout-details">
                  {dateOnly && (
                    <h6 className="checkout-item">
                      <strong>Day:</strong> {dateOnly}
                    </h6>
                  )}
                  {cutTime && (
                    <h6 className="checkout-item">
                      <strong>Time:</strong> {cutTime}
                    </h6>
                  )}
                  {selectedBarber && (
                    <h6 className="checkout-item">
                      <strong>Barber:</strong> {selectedBarber}
                    </h6>
                  )}
                  {selectedHairName && hPrice && (
                    <h6 className="checkout-item">
                      <strong>Hair:</strong> {selectedHairName}{" "}
                      <span className="price">${hPrice}</span>
                    </h6>
                  )}
                  {selectedBeardName && bPrice && (
                    <h6 className="checkout-item">
                      <strong>Beard:</strong> {selectedBeardName}{" "}
                      <span className="price">${bPrice}</span>
                    </h6>
                  )}
                  {selectedFaceName && fPrice && (
                    <h6 className="checkout-item">
                      <strong>Face:</strong> {selectedFaceName}{" "}
                      <span className="price">${fPrice}</span>
                    </h6>
                  )}
                  <hr />
                  <h6 className="checkout-item total">
                    {parseFloat(hPrice || 0) +
                      parseFloat(bPrice || 0) +
                      parseFloat(fPrice || 0) >
                      0 && (
                      <>
                        <strong>Total:</strong> $
                        {parseFloat(hPrice || 0) +
                          parseFloat(bPrice || 0) +
                          parseFloat(fPrice || 0)}
                      </>
                    )}
                  </h6>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {!loadingSubmit && (
            <Button variant="primary" onClick={(e) => createAppoitment(e)}>
              Submit
            </Button>
          )}
          {loadingSubmit && (
            <Button variant="primary" disabled>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Loading...
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BookCut;
